import { Box, Button, Card, Typography } from "@mui/material";
import { styled } from '@mui/styles'

export const upimg = 'https://upobpas.in/BPAMSClient/seConfigFiles/images/HomePage/logo.png'
export const bannerImgUrls = [
  'https://i.imgur.com/CVonZnW.jpeg',
  'https://i.imgur.com/Kq5MXT0.jpeg',
  // 'https://i.imgur.com/FjaJFlp.jpeg',
]
export const PageWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  height: '100vh',
  width: '100vw',
  marginTop: theme.spacing(-10),
}));

export const SliderWrapper = styled(Box)(({ theme }) => ({
  width: '50%',
  //backgroundColor: theme.palette.awasbandhu.primary.main, // Change this to suit the slider
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  overflow: 'hidden',
  position: 'relative',
  padding: '2rem',
  boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.2)',
}));

export const Slide = styled(Box)(({ theme }) => ({
  width: '100%',
  height: '100%',
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  transition: 'background-image 1s ease-in-out', // Smooth transitions
}));

export const LoginCard = styled(Card)(({ theme }) => ({
  width: '50%',
  padding: '2rem',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  boxShadow: '    rgba(0, 0, 0, 0.25) 0px 54px 55px, rgba(0, 0, 0, 0.12) 0px -12px 30px, rgba(0, 0, 0, 0.12) 0px 4px 6px, rgba(0, 0, 0, 0.17) 0px 12px 13px, rgba(0, 0, 0, 0.09) 0px -3px 5px',
}));

export const StyledButton = styled(Button)(({ theme }) => ({
  backgroundColor: theme.palette.awasbandhu.primary.main,
  color: '#fff',
  marginTop: '1rem',
  width: '100%',
  boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.2)', // Button shadow
  '&:hover': {
    backgroundColor: theme.palette.awasbandhu.primary.dark,
  },
}));

export const EmployeeLoginLink = styled(Typography)(({ theme }) => ({
  color: theme.palette.awasbandhu.primary.main,
  marginTop: '1rem',
  cursor: 'pointer',
  textDecoration: 'underline',
}));

export const StyledHeading = styled(Typography)({
  fontWeight: 'bold',
  fontSize: '1.2rem',
  textAlign: 'center',
  marginTop: '1rem',
  marginBottom: '2rem',
  marginLeft: '1rem'
});

export const StyledImage = styled('img')({
  width: '100px',
  height: 'auto',
  marginBottom: '1rem',
});

export const ButtonStripWrapper = styled(Box)(() => ({
  backgroundColor: 'rgb(230, 239, 248)',
  padding: '1rem',
  display: 'flex',
  justifyContent: 'space-between',
  gap: '2rem'
}));

export const StyledButtons = styled(Button)(({ theme }) => ({
  backgroundColor: theme.palette.awasbandhu.primary.main,
  color: '#fff',
  marginTop: '1rem',
  width: '10rem',
  padding: '12px',
  fontSize: '11px',
  boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.2)', // Button shadow
  '&:hover': {
    backgroundColor: theme.palette.awasbandhu.primary.dark,
  },
}));
export const SlideWrapper = styled(Box)(({ theme, bgimg }) => ({
  background: `linear-gradient(rgba(0, 30, 139, 0.3), rgba(0, 30, 139, 0.3)), url('${bgimg}') center center / cover no-repeat`, // Apply dimming effect
  transition: `background 1.5s ease-in-out`,
  position: 'relative',
  minHeight: `calc(100dvh - 50px)`,
  width: '100%',
  [theme.breakpoints.up('lg')]: {
    minHeight: `calc(100dvh - 50px)`,
  },
  '::before': {
    content: '""',
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.4)', // Add a semi-transparent overlay
    zIndex: 1, // Ensure the overlay is on top of the background
  },
}))

export const WelcomeSlideText = styled(Box)(({ theme, isVisible }) => ({
  fontSize: '1.5rem',
  fontWeight: '600',
  color: '#fff',
  margin: 'auto',
  transition: 'transform 1s ease-in-out, opacity 1s ease-in-out',
  fontFamily: '"Raleway", sans-serif',
  display: 'flex',           // Enable flexbox
  justifyContent: 'center',   // Horizontally center the text
  alignItems: 'center',
  marginTop: '30%'
}));